(function () {
  'use strict';

  angular
    .module('vcfinance.closing', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
